import React, { useState } from "react";
import { Formik, Field, Form } from 'formik';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';
import { Radio, TextField } from "./form";
import UploadIcon from '@material-ui/icons/Upload'
import { makeStyles } from "@material-ui/styles";
import toast from 'react-hot-toast';
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    maxWidth: '50%',
    margin: '0 auto'
  }
});

export const EditProductForm = ({ product, onSave }) => {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const onSubmit = async values => {
    const payload = {
      title: values.title,
      price: values.price,
      enabled: values.enabled,
      deleteFile: values.deleteFile,
    }

    const optional = ['body', 'description', 'file'];
    optional.forEach(k => {
      if (values[k]) {
        payload[k] = values[k]
      }
    });

    setLoading(true);
    try {
      await onSave(product.id, payload);
      toast('Listing Updated');
    } catch (e) {
      if (e.response?.data?.message) {
        toast("Couldn't update the listing. " + e.response.data.message);
      } else {
        toast(`Something went wrong: ${e.message}`);
      }
    } 

    setLoading(false);
  }

  return (
    <div className={classes.root}>
      <Formik
        initialValues={{
          title: product.title,
          description: product.description || '',
          price: product.price,
          enabled: product.enabled,
          body: product.body || '',
          productValueType: product.body ? 'text' : 'file',
          uploadedFile: product.file?.filename,
          deleteFile: false,
          ...product,
          file: undefined
        }}
        onSubmit={onSubmit}
      >
        {({ values, dirty, handleChange, setFieldValue }) => {
          const filename = values.uploadedFile || values.file?.name;
          return (
            <Form>
              <div>
                <Field
                  component={TextField}
                  label="Title"
                  margin="normal"
                  type="text"
                  name="title"
                  fullWidth
                  placeholder="Title"
                  required
                />
              </div>

              <div>
                <Field
                  component={TextField}
                  multiline
                  fullWidth
                  label="Description"
                  type="text"
                  name="description"
                  margin="normal"
                />
              </div>

              <div>
                <Field
                  component={TextField}
                  label="Price (ETH)"
                  type="number"
                  step="any"
                  name="price"
                  margin="normal"
                  required
                />
              </div>

              <div role="group" aria-labelledby="my-radio-group">
                <label>Type</label>{' '}
                <label>
                  <Field component={Radio} type="radio" name="productValueType" value="file" />File
                </label>
                <label>
                  <Field component={Radio} type="radio" name="productValueType" value="text" />Text
                </label>
              </div>

              {values.productValueType === 'text' && (
                <div>
                  <Field
                    component={TextField}
                    style={{
                      marginTop: 15
                    }}
                    label="Secret Contents"
                    fullWidth
                    multiline
                    margin="normal"
                    type="text"
                    name="body"
                  />
                </div>
              )}

              {values.productValueType === 'file' && (
                <div>
                  {filename ? (
                    <div>
                      {filename}{' '}
                      <Button
                        variant='outlined'
                        type="button"
                        color="secondary"
                        onClick={event => {
                          setFieldValue('deleteFile', true);
                          setFieldValue('uploadedFile', undefined);
                          setFieldValue('file', undefined);
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  ) : (
                    <Button
                      variant="contained"
                      color="secondary"
                      component="label"
                    >
                      <UploadIcon /> Choose a file...
                      <input
                        id="file"
                        type="file"
                        name="file"
                        hidden
                        onChange={(event) => {
                          setFieldValue("file", event.currentTarget.files[0]);
                        }}
                      />
                    </Button>
                  )}
                </div>
              )}

              <div>
                <label>Visible?</label>
                <Switch
                  checked={values.enabled}
                  onChange={handleChange}
                  name="enabled"
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
              </div>


              <div className="form-group" style={{marginTop: 25}}>
                <Button disabled={!dirty} variant="contained" size={'large'} type="submit">
                  {loading && <CircularProgress color="info" />}
                  Save
                </Button>
                <Button><Link style={{textDecoration: 'none'}} to={`/products/${product.id}`}>View Listing</Link></Button>
              </div>

            </Form>
          )
        }}
      </Formik>
    </div>
  );
}
